@<!--
 * @Description: 提交提醒
 * @Author: maqinghe 
 * @Date: 2025年10月27日 14:55:57
-->
<template>
  <div class="auth-users">
    <el-form label-width="0px">
      <el-form-item label="" prop="wkNo">
        <div class="search-wrap">
          <el-input type="text" v-model="searchText" autocomplete="on" class="auth-input" placeholder="姓名/工号，搜索表格数据" clearable></el-input>
          <el-button type="primary" class="auth-btn" native-type="submit" @click.prevent="queryUserList" plain>搜索</el-button>
          <el-button type="primary" plain @click="getAllData">返回全部结果</el-button>
        </div>
      </el-form-item>

    </el-form>
    <vxe-table
      row-key
      column-key
      show-overflow
      show-header-overflow
      highlight-hover-row
      highlight-current-row
      auto-resize
      height="360"
      v-loading="loading"
      ref="userTable"
      :scroll-y="{gt: 50, oSize: 5}" 
      :data="tableData"
      :keyboard-config="{isArrow: true}"
    >
      <vxe-column type="seq" title="序号" fixed="left" width="100"></vxe-column>
      <vxe-column field="configWkNo" :formatter="nameFormat" type="html" title="工号"></vxe-column>
      <vxe-column field="configWkName" :formatter="nameFormat" type="html" title="姓名"></vxe-column>
      <vxe-column field="" title="操作" fixed="right" width="60" class-name="operation">
        <template #default="scope">
          <div><i class='icon-close delete' @click.stop='deleteRow(scope.row, scope.rowIndex)'></i></div>
        </template>
      </vxe-column>
    </vxe-table>
    <div class="atb-text-right" style="margin-top: 10px;">
      <!-- 保存 -->
      <el-button class="atb-dialog-confirm" type="primary" @click="submit" style="margin-left: 0;">确定</el-button>
      <!-- 取消 -->
      <el-button class="atb-dialog-cancel" type="cancel" @click="$parent.$parent.hide();">取消</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommitRemind',
  props: {
    param: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      loading: false,
      editForm: { wkNos: []},
      initselectData: [],
      isLoaded: false,
      searchText: '',
      tableAllData: [],
      tableData: [],

      userKeyMap: {},
    }
  },
  created() {
    this.getUsers();
  },
  methods: {
    validate(evt) {
      var theEvent = evt || window.event;
      var key = theEvent.charCode || theEvent.which;

      if (key >= 32 && (theEvent.ctrlKey === undefined || !theEvent.ctrlKey)) {
        if(theEvent.preventDefault) theEvent.preventDefault();
        else theEvent.returnValue = false;
      }
    },
    getUsers() {
      this.$ajax.post(this.$api.period.importanceSortManage.getCommitList, {
        ...this.param,
        status: this.param.status || this.param.status === 0 ? this.param.status : undefined,
      }).then((res) => {
        let list = res.data.result || [];
        list.forEach(item => {
          item.visibleDelete = false;
        });
        this.tableAllData = this.tableData = list;
        this.$nextTick(() => {
          this.tableAllData.forEach(item => {
            this.userKeyMap[item.configWkNo] = item.configWkName;
          });
        });
      }).finally(() => {
        this.isLoaded = true;
      });
    },

    // 添加用户时，获取所有用户，打开弹窗，选择用户
    queryUserList() {
      const self = this;
      const tableAllData = this.tableAllData;
      this.loading = true;

      const endFn = function() {
        self.loading = false;   
        setTimeout(() => {
          self.$refs['userTable'] && self.$refs['userTable'].scrollTo(0, 0);
        }, 0)
      }

      this.tableData = tableAllData.filter(v => {
        let reg = new RegExp(this.searchText, 'gi');
        return reg.test(v.configWkName) || reg.test(v.configWkNo);
      })
      endFn();
    },
    nameFormat({ cellValue }) {
      let keyword = this.searchText;
      if(keyword) {
        return this.highlight(cellValue, [keyword], 'span');
      } else {
        return cellValue;
      }
    },
    highlight(text, words, tag) {
      tag = tag || 'span';
      Array.prototype.forEach.call(words, function(v, i) {
        let reg = new RegExp(words[i], 'gi');
        if (reg.test(text)) {
          text = text.replace(reg, '<'+ tag +' class="light">$&</'+ tag +'>');
        }
      })
      return text;
    },
    deleteRow(row, rowIndex) {
      // row.visibleDelete = true;
      this.confirmDel(row, rowIndex);
    },
    confirmDel(row, rowIndex) {
      let index = this.tableAllData.findIndex((item) => item.configWkNo === row.configWkNo);
      index !== -1 && this.tableAllData.splice(index, 1);
      if (this.tableAllData !== this.tableData) {
        this.tableData.splice(rowIndex, 1);
      }
      row.visibleDelete = false;
      this.userKeyMap[row.configWkNo] = null;
    },
    cancelDel(row) {
      row.visibleDelete = false;
    },
    submit() {
      let wkNos = [];
      this.tableAllData.forEach(item => {
        wkNos.push(item.configWkNo);
      });
      let params = {
        wkNos,
        year: this.param.year,
        period: this.param.period,
      }
      this.$ajax.post(this.$api.period.importanceSortManage.commitRemind, params).then((res) => {
        if (res.code === 0) {
          this.$parent.$parent.hide();
          this.$router.push({
            path: '/manage/export-task/index',
          });
        }
      });
    },
    getAllData() {
      this.tableData = this.tableAllData;
      this.searchText = '';
      this.$refs['userTable'] && this.$refs['userTable'].scrollTo(0, 0);
    }
  }
}
</script>
<style lang="scss">
  .light {
    color: $--color-primary;
  }
  .auth-users {
    .el-form-item {
      margin-bottom: 16px;
    }
    .icon-close {
      color: red;
      cursor: pointer;
    }
    .search-wrap {
      display: flex;
      .auth-input {
        flex: 1;
        .el-input__inner {
          border-top-right-radius: 0; 
          border-bottom-right-radius: 0; 
        }
      }
      .auth-btn {
        flex: 0 0 auto;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
</style>
